module.exports = __webpack_public_path__ + "static/media/adaptive-icon.896b936b.png";